export default "__VITE_ASSET__BvGayM5Z__"